import React from 'react';

export const CustomerRegisterStep2 = ({ agreements, handleAgreement, goToStep3 }) => {
  const AgreementItem = ({ type, title, isRequired, link }) => (
    <div className="register-area__agree-mendatory-btn-block">
      <img 
        className="register-area__agree-mendatory-btn-icon" 
        src={agreements[type] ? "/icons/icon_check_active.svg" : "/icons/icon_check.svg"}
        onClick={() => handleAgreement(type)}
        alt="체크 아이콘"
      />
      <div className={`register-area__agree-${isRequired ? 'mendatory' : 'optional'}-btn-text`}>
        [{isRequired ? '필수' : '선택'}] {title}
      </div>
      <img 
        className="register-area__agree-mendatory-btn-info-icon" 
        src="/icons/icon_rightarrow.png"
        onClick={() => window.open(link, '_blank')}
        style={{ cursor: 'pointer' }}
        alt="상세보기"
      />
    </div>
  );

  return (
    <div className="register-area">
      <div className="register-area__agree-all-btn-block" onClick={() => handleAgreement('all')}>
        <img 
          className="register-area__agree-all-btn-icon" 
          src={agreements.all ? "/icons/icon_check_active.svg" : "/icons/icon_check.svg"} 
          alt="전체 동의"
        />
        <div className="register-area__agree-all-btn-text">약관 전체 동의</div>
      </div>

      <div className="register-area__agree-mendatory-text">필수 동의 항목</div>
      <AgreementItem 
        type="terms"
        title="이용약관"
        isRequired={true}
        link="https://docs.google.com/document/d/114zQPH5UyiAoLPQT7USVK5bCLcIpKifdYwQDQh752zw/edit?usp=sharing"
      />
      <AgreementItem 
        type="privacy"
        title="개인정보 수집 및 이용 동의"
        isRequired={true}
        link="https://docs.google.com/document/d/1znqpLk-QoA5G8f9fWghdrQy_a8Gp42S7Fn1xggngL8Y/edit?usp=sharing"
      />
      <AgreementItem 
        type="location"
        title="위치기반 서비스 이용 동의"
        isRequired={true}
        link="https://docs.google.com/document/d/1i_3xE5vqrbyMzFPKSOdDw0BPXcj_J8ldcL94RtsSCYc/edit?usp=sharing"
      />
      <AgreementItem 
        type="thirdParty"
        title="제3자 제공 동의"
        isRequired={true}
        link="https://docs.google.com/document/d/1s42ibT4h2_Qtzn0EIKw4wqf834SaBM_To-FnYAt3qH4/edit?usp=sharing"
      />
      <AgreementItem 
        type="payment"
        title="결제 정보 처리 동의"
        isRequired={true}
        link="https://docs.google.com/document/d/1_70t0UKky_Xnc0v_v9Ks47j66uCiHZHwUtJ-kkXX_pg/edit?usp=sharing"
      />
      <AgreementItem 
        type="minor"
        title="미성년자 이용 제한 동의"
        isRequired={true}
        link="https://docs.google.com/document/d/1SuySPYPSdPfJKrtkhY_dM024PMoE8L1wDlXOnS_FXeQ/edit?usp=sharing"
      />

      <div className="register-area__agree-optional-text">선택 동의 항목</div>
      <AgreementItem 
        type="marketing"
        title="마케팅 및 광고 활용 동의"
        isRequired={false}
        link="https://docs.google.com/document/d/12v1-mQ21sJ_wZqGEKoQTOvyAySh_feFl7HJO6bLi9AM/edit?usp=sharing"
      />
      <AgreementItem 
        type="personalService"
        title="개인 맞춤형 서비스 제공 동의"
        isRequired={false}
        link="https://docs.google.com/document/d/1cuITtTRI-w3a1qj1N2J66ERNsdLWoCguKkoBdTOvvyk/edit?usp=sharing"
      />
      <AgreementItem 
        type="affiliate"
        title="제휴 서비스 이용 동의"
        isRequired={false}
        link="https://docs.google.com/document/d/1cuITtTRI-w3a1qj1N2J66ERNsdLWoCguKkoBdTOvvyk/edit?usp=sharing"
      />
      <AgreementItem 
        type="cookie"
        title="쿠키 수집 동의"
        isRequired={false}
        link="https://docs.google.com/document/d/1cuITtTRI-w3a1qj1N2J66ERNsdLWoCguKkoBdTOvvyk/edit?usp=sharing"
      />

      <div 
        className={`register-area__nextstep-btn-block${
          agreements.terms && agreements.privacy && agreements.location && 
          agreements.thirdParty && agreements.payment && agreements.minor
          ? '--active' 
          : '--inactive'
        }`}
        onClick={goToStep3}
      >
        <div className="register-area__nextstep-btn-text">다음단계</div>
      </div>
    </div>
  );
};